import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {DivulgacaoFornecedor,IDivulgacaoFornecedor} from '../../../../models/divulgacao.model';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'item-fornecedor',
    templateUrl: 'item.fornecedor.html',
    styleUrls:['item.fornecedor.css']
})

export class ItemFornecedorComponent implements OnInit, OnDestroy {
    fValue:any;
    fDivulgacaoStat: DivulgacaoFornecedor;    
    @Input() 
     set value(x){
       this.fValue = x;
       if (x.codigo>0){
        this.fDivulgacaoStat.addDivulgacao(x.codigo,'produtos',1);
       }
     };
     get value(){
         return this.fValue;
     }
    @Input() index = -1;

    constructor(private db :AngularFirestore) {
        this.fDivulgacaoStat = new DivulgacaoFornecedor(this.db);
     }

    ngOnInit(){
     }
    ngOnDestroy(){
        this.fDivulgacaoStat.postList();
    }
}